(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon/assets/javascripts/coupon-row.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon/assets/javascripts/coupon-row.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const _React = React,
  useContext = _React.useContext;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const Badge = svs.ui.ReactBadge;
const clx = svs.components.lbUtils.clx;
const selectSystemType = svs.components.tipsen.engine.selectors.couponSelectors.selectSystemType;
const DescriptionSize = svs.components.lbUi.participants.constants.DescriptionSize;
const _svs$components$tipse = svs.components.tipsen.coupon,
  CouponRowDescription = _svs$components$tipse.CouponRowDescription,
  ReduceFreeBets = _svs$components$tipse.ReduceFreeBets,
  VideoAnalysisController = _svs$components$tipse.VideoAnalysisController;
const Tipsinfo = svs.components.tipsen.tipsinfo.Tipsinfo;
const CouponRowMatchAnalyses = svs.components.tipsen.couponRowMatchAnalyses.CouponRowMatchAnalyses;
const CouponBetButtons = svs.components.tipsen.couponBetButtons.CouponBetButtons;
const useBetEvent = svs.components.sportinfo.matchInfoHooks.useBetEvent;
const _svs$components$tipse2 = svs.components.tipsen.hooks,
  useBranding = _svs$components$tipse2.useBranding,
  useIsTipsinfoEnabled = _svs$components$tipse2.useIsTipsinfoEnabled;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const SYSTEM_REDUCERA_FRITT = svs.components.tipsen.engine.constants.systems.SYSTEM_REDUCERA_FRITT;
const _svs$components$tipse3 = svs.components.tipsen.selectors,
  selectDrawEvent = _svs$components$tipse3.selectDrawEvent,
  selectShowCompressedCoupon = _svs$components$tipse3.selectShowCompressedCoupon,
  selectShowMatchAnalyseText = _svs$components$tipse3.selectShowMatchAnalyseText,
  selectShowVideoAnalysesInCoupon = _svs$components$tipse3.selectShowVideoAnalysesInCoupon;
const TipsenLink = svs.components.tipsen.tipsen_link.TipsenLink;
const getEventLink = svs.components.tipsen.tipsen_link.utils.getEventLink;
const DrawContext = svs.components.tipsen.drawProvider.DrawContext;
const useDrawSearchParams = svs.components.tipsen.drawProvider.hooks.useDrawSearchParams;
const STATISTIC_SIDEBAR_QUERY = svs.components.tipsen.constants.STATISTIC_SIDEBAR_QUERY;
const _svs$components$sport = svs.components.sportinfo.common.constants,
  EventTypeField = _svs$components$sport.EventTypeField,
  EventTypeDistributionsFallback = _svs$components$sport.EventTypeDistributionsFallback;
const RenderContext = svs.component.tipsen.renderContext.RenderContext;
const getAriaLabelForEvent = svs.components.poolBetting.ariaUtils.getAriaLabelForEvent;
const selectParticipant = svs.components.sportinfo.matchInfoRedux.selectors.selectParticipant;
const selectHasAnyVideos = svs.components.tipsen.store.reducers.videoAnalysesSlice.selectors.selectHasAnyVideos;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const getProductBrandByDraw = svs.components.lbUtils.brandMapping.fn.getProductBrandByDraw;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const isVideoAnalysesFeatureEnabled = !isSelfService && svs.core.detect.feature('ft-pool-betting-video-analyses');
const CouponRow = _ref => {
  var _productDistribution$;
  let couponId = _ref.couponId,
    board = _ref.board,
    eventIndex = _ref.event,
    outcomeLabels = _ref.outcomeLabels,
    hasDisabledBets = _ref.hasDisabledBets,
    isSelected = _ref.isSelected;
  const _useContext = useContext(RenderContext),
    pageType = _useContext.pageType;
  const _useContext2 = useContext(DrawContext),
    productId = _useContext2.productId,
    drawNumber = _useContext2.drawNumber;
  const drawId = "".concat(productId, "_").concat(drawNumber);
  const drawEvent = useSelector(state => selectDrawEvent(state, drawId, eventIndex));
  const systemType = useSelector(state => selectSystemType(state, couponId));
  const isReduceFree = systemType === SYSTEM_REDUCERA_FRITT;
  const draw = useCurrentDraw();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const hasAnyVideos = useSelector(selectHasAnyVideos);
  const _useIsTipsinfoEnabled = useIsTipsinfoEnabled(),
    isAnyTipsinfoEnabled = _useIsTipsinfoEnabled.isAnyTipsinfoEnabled,
    isSvenskaFolketAsOutcomesEnabled = _useIsTipsinfoEnabled.isSvenskaFolketAsOutcomesEnabled;
  const _useBetEvent = useBetEvent({
      productId,
      drawNumber,
      eventNumber: drawEvent.eventNumber
    }),
    betEvent = _useBetEvent.betEvent,
    eventStatistics = _useBetEvent.eventStatistics;
  let productDistribution = [];
  if (eventStatistics) {
    var _eventStatistics$Even, _ref2, _eventStatisticsProdu;
    const eventStatisticsProductId = (_eventStatistics$Even = eventStatistics[EventTypeField.Distributions]) === null || _eventStatistics$Even === void 0 ? void 0 : _eventStatistics$Even[productId];
    productDistribution = (_ref2 = (_eventStatisticsProdu = eventStatisticsProductId === null || eventStatisticsProductId === void 0 ? void 0 : eventStatisticsProductId[drawNumber]) !== null && _eventStatisticsProdu !== void 0 ? _eventStatisticsProdu : eventStatisticsProductId === null || eventStatisticsProductId === void 0 ? void 0 : eventStatisticsProductId[EventTypeDistributionsFallback]) !== null && _ref2 !== void 0 ? _ref2 : [];
  }
  const hasDistribution = productDistribution && (((_productDistribution$ = productDistribution.current) === null || _productDistribution$ === void 0 ? void 0 : _productDistribution$.value) || []).filter(v => Boolean(v)).length > 0;
  const defaultOutcomes = outcomeLabels.map(el => el.text);
  let outcomes;
  if (hasDistribution && isSvenskaFolketAsOutcomesEnabled) {
    outcomes = defaultOutcomes.map((el, i) => productDistribution.current.value[i] ? "".concat(productDistribution.current.value[i], "%") : '-');
  } else {
    outcomes = defaultOutcomes;
  }
  const toParams = useDrawSearchParams(productId, drawNumber, drawEvent.eventNumber);
  const searchParams = new URLSearchParams(toParams);
  const showCouponAndDetailView = useMediaQuery(STATISTIC_SIDEBAR_QUERY);
  if (!showCouponAndDetailView) {
    searchParams.set('openStatistic', '');
  }
  const showVideoAnalysesInCoupon = useSelector(selectShowVideoAnalysesInCoupon);
  const shouldShowVideoAnalysis = isVideoAnalysesFeatureEnabled && showVideoAnalysesInCoupon && hasAnyVideos;
  const showMatchAnalysesInCoupon = useSelector(state => selectShowMatchAnalyseText(state, pageType));
  let showCompressedCoupon = useSelector(selectShowCompressedCoupon);
  showCompressedCoupon = useMediaQuery(breakpoints.down(BREAKPOINT_SM)) ? showCompressedCoupon : false;
  const couponRowClassNames = clx('coupon-row', {
    ["coupon-row-".concat(branding)]: branding,
    'coupon-row-compressed': showCompressedCoupon,
    'coupon-row-reduce-free': isReduceFree,
    'coupon-row--selected': isSelected
  });
  const containerClassNames = clx('coupon-row-container', {
    ["".concat(branding)]: branding.length > 1
  });
  const nameSize = DescriptionSize.Full;
  const homeParticipant = useSelector(state => {
    var _betEvent$participant;
    return selectParticipant(state, betEvent === null || betEvent === void 0 || (_betEvent$participant = betEvent.participants) === null || _betEvent$participant === void 0 ? void 0 : _betEvent$participant[0]);
  });
  const awayParticipant = useSelector(state => {
    var _betEvent$participant2;
    return selectParticipant(state, betEvent === null || betEvent === void 0 || (_betEvent$participant2 = betEvent.participants) === null || _betEvent$participant2 === void 0 ? void 0 : _betEvent$participant2[1]);
  });
  return React.createElement("li", {
    className: containerClassNames,
    id: "event-".concat(betEvent.eventNumber)
  }, React.createElement(TipsenLink, _extends({
    "aria-label": getAriaLabelForEvent({
      eventTypeId: betEvent.eventTypeId,
      homeParticipant,
      awayParticipant
    }),
    className: couponRowClassNames,
    disabled: isSelected && showCouponAndDetailView,
    to: {
      pathname: getEventLink(),
      search: "?".concat(searchParams)
    }
  }, isSelected && showCouponAndDetailView ? {
    'aria-current': 'page'
  } : {}), !showCompressedCoupon && React.createElement(Badge, {
    branding: branding,
    className: "coupon-row-number f-500"
  }, drawEvent.eventNumber), shouldShowVideoAnalysis && React.createElement(VideoAnalysisController, {
    eventNumber: drawEvent.eventNumber
  }), React.createElement(CouponRowDescription, {
    eventNumber: showCompressedCoupon ? betEvent.eventNumber : null,
    eventTypeId: betEvent.eventTypeId,
    nameSize: nameSize,
    participants: betEvent.participants
  }), isReduceFree ? React.createElement("div", {
    className: "coupon-row-reduce-free-outcomes"
  }, React.createElement(ReduceFreeBets, {
    board: board,
    couponId: couponId,
    event: eventIndex,
    isDisabled: hasDisabledBets,
    outcomeLabels: outcomeLabels
  })) : React.createElement(CouponBetButtons, {
    awayParticipant: awayParticipant,
    board: board,
    couponId: couponId,
    event: eventIndex,
    eventTypeId: betEvent.eventTypeId,
    hasDisabledBets: hasDisabledBets,
    homeParticipant: homeParticipant,
    isSvenskaFolketAsOutcomesEnabled: isSvenskaFolketAsOutcomesEnabled,
    outcomeLabels: outcomeLabels,
    outcomes: outcomes
  }), isAnyTipsinfoEnabled && React.createElement("div", {
    className: "pg_coupon-row_tipsinfo"
  }, React.createElement(Tipsinfo, {
    drawId: drawId,
    drawNumber: drawNumber,
    eventNumber: drawEvent.eventNumber,
    isReduceFree: isReduceFree,
    outcomeLabels: outcomeLabels,
    productId: productId
  })), showMatchAnalysesInCoupon && React.createElement(CouponRowMatchAnalyses, {
    drawNumber: drawNumber,
    eventNumber: drawEvent.eventNumber,
    matchId: betEvent.matchId,
    productId: productId
  }), betEvent.eventComment && React.createElement("div", {
    className: "tipsinfo-event-comment"
  }, betEvent.eventComment)));
};
setGlobal('svs.components.tipsen.coupon.CouponRow', CouponRow);

 })(window);